import client from './axios';

const sessionCache = new Map();
const sessionPromises = new Map();

export const academicSessionsApi = {
  create: async (data) => {
    sessionCache.clear();
    sessionPromises.clear();
    const response = await client.post('/academic-sessions/', data);
    return response.data;
  },

  getAllBySchool: async (schoolId, force = false) => {
    if (!schoolId) return [];
    if (!force && sessionCache.has(schoolId)) {
      return sessionCache.get(schoolId);
    }
    if (sessionPromises.has(schoolId)) {
      return sessionPromises.get(schoolId);
    }

    const promise = client.get(`/academic-sessions/?school_id=${schoolId}`)
      .then(response => {
        sessionCache.set(schoolId, response.data);
        sessionPromises.delete(schoolId);
        return response.data;
      })
      .catch(err => {
        sessionPromises.delete(schoolId);
        throw err;
      });

    sessionPromises.set(schoolId, promise);
    return promise;
  },

  getCurrentBySchool: async (schoolId) => {
    const response = await client.get(`/academic-sessions/current?school_id=${schoolId}`);
    return response.data;
  },

  getById: async (id) => {
    const response = await client.get(`/academic-sessions/${id}`);
    return response.data;
  },

  update: async (id, data) => {
    sessionCache.clear();
    sessionPromises.clear();
    const response = await client.put(`/academic-sessions/${id}`, data);
    return response.data;
  },

  setCurrent: async (id) => {
    sessionCache.clear();
    sessionPromises.clear();
    const response = await client.patch(`/academic-sessions/${id}/set-current`);
    return response.data;
  },

  updateStatus: async (id, status) => {
    sessionCache.clear();
    sessionPromises.clear();
    const response = await client.patch(`/academic-sessions/${id}/status`, { status });
    return response.data;
  },

  invalidateCache: (schoolId) => {
    if (schoolId) {
      sessionCache.delete(schoolId);
      sessionPromises.delete(schoolId);
    } else {
      sessionCache.clear();
      sessionPromises.clear();
    }
  },
};
